<template>
  <b-row>
    <b-col sm="12">
      <IndexCreditRefundTableModel ref="IndexCreditRefundTableModel" />

      <TableDataServerSide
        :ref="`tableUserInfoCreditPurchase`"
        :url="_url"
        @clickNew="$refs[`IndexCreditRefundTableModel`].show()"
        @clickView="$refs[`IndexCreditRefundTableModel`].show($event)"
        @clickEdit="$refs[`IndexCreditRefundTableModel`].show({ ...$event })"
        @clickDelete="$refs.tableUserInfo.clickDelete('/api/admin/userTransactionData', $event)"
        :columns="_columns"
        :newAble="false"
        :viewAble="false"
        :editAble="false"
        :deleteAble="false"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'IndexPurchaseCreditTable',
  components: {
    IndexCreditRefundTableModel: () => import('./IndexCreditRefundTable/IndexCreditRefundTableModel.vue'),
  },
  props: {
    url: {
      type: String,
      default: '/api/admin/userTransactionData?filter=creditRefund',
    },
  },
  computed: {
    _url() {
      return this.url
    },
    _role() {
      return this.role.role
    },

    _columns() {
      let columns = [
        {
          label: 'ชื่อ สกุล',
          field: 'user_as_name',
        },
        {
          label: 'เลขอ้างอิง',
          field: 'transaction_data_as_ref',
        },
        {
          label: 'เครดิต เดิม',
          field: 'transaction_data_as_credit_balance',
          type: 'number',
          tdClass: 'text-right',
        },
        {
          label: 'เครดิต เติม',
          field: 'transaction_data_as_credit_amount',
          type: 'number',
          tdClass: 'text-right',
        },
        {
          label: 'เครดิต รวม',
          field: 'transaction_data_as_credit_total',
          type: 'number',
          tdClass: 'text-right',
        },
        // {
        //   label: 'ช่องทางการเติม',
        //   field: 'payment_chanel',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },

        {
          label: 'สถานะ',
          field: 'transaction_data_as_status_text',
          tdClass: 'text-center',
        },
        {
          label: 'วันที่',
          field: 'created_at',
          formatFn: value => this.$date(value).format('YYYY-MM-DD HH:mm:ss'),
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        // {
        //   label: '',
        //   field: 'action',
        // },
      ]
      return columns
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-good-table.scss';
</style>
